import { useEffect, useState } from "react";
import { Trash2, Copy } from "lucide-react";
import { apiClient } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminNewsletter() {
  const [subscribers, setSubscribers] = useState([]);

  const fetchSubscribers = () => apiClient.get("/admin/newsletter-subscribers").then((res) => setSubscribers(res.data));
  useEffect(() => { fetchSubscribers(); }, []);

  const handleDelete = async (s) => {
    if (!window.confirm(`Remove ${s.email} from the newsletter list?`)) return;
    try {
      await apiClient.delete(`/admin/newsletter-subscribers/${s.id}`);
      toast.success("Subscriber removed");
      fetchSubscribers();
    } catch {
      toast.error("Could not remove subscriber");
    }
  };

  const copyAll = () => {
    navigator.clipboard.writeText(subscribers.map((s) => s.email).join(", "));
    toast.success("All emails copied to clipboard");
  };

  return (
    <div data-testid="admin-newsletter-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-semibold text-slate-900">Newsletter Subscribers</h1>
        <div className="flex items-center gap-3">
          <span className="text-sm text-slate-500" data-testid="admin-newsletter-count">{subscribers.length} subscriber{subscribers.length === 1 ? "" : "s"}</span>
          {subscribers.length > 0 && (
            <Button size="sm" variant="outline" className="rounded-md" onClick={copyAll} data-testid="admin-newsletter-copy-all">
              <Copy className="h-3.5 w-3.5 mr-1.5" /> Copy All Emails
            </Button>
          )}
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-slate-600">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">Email</th><th className="px-4 py-3">Subscribed</th><th className="px-4 py-3"></th></tr>
          </thead>
          <tbody>
            {subscribers.map((s) => (
              <tr key={s.id} className="border-t border-slate-100" data-testid={`admin-newsletter-row-${s.id}`}>
                <td className="px-4 py-3 font-medium text-slate-900">{s.email}</td>
                <td className="px-4 py-3">{new Date(s.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3 text-right">
                  <Button size="sm" variant="outline" onClick={() => handleDelete(s)} data-testid={`admin-delete-subscriber-${s.id}`}>
                    <Trash2 className="h-3.5 w-3.5 text-red-500" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {subscribers.length === 0 && <p className="p-6 text-center text-slate-400 text-sm" data-testid="admin-no-subscribers">No newsletter subscribers yet. Signups from the footer email bar appear here.</p>}
      </div>
    </div>
  );
}
